export const GET_WEB_BASIC = 'GET_WEB_BASIC';
export const GET_PMCS = 'GET_PMCS';
export const GET_WEB_DETAILED = 'GET_WEB_DETAILED';
export const SET_ONLINE_SALES_FILTERS = 'SET_ONLINE_SALES_FILTERS';
